// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    
    

    /*
    render function
    */
    import { awCustomLOVComponentRenderFunction } from 'js/CustomLOVComponentService';
    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/CustomLOVComponentService', () => import('js/CustomLOVComponentService'));
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/DesCatalogPartSummaryService', () => import('js/DesCatalogPartSummaryService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "actions": {
        "render": {
            "method": "awCustomLOVComponentRenderFunction",
            "deps": "js/CustomLOVComponentService"
        },
        "enableTableConfiguration": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "catalogspaceId": "{{data.catalogspaceId}}",
                            "feature": "{{ctx.feature}}"
                        },
                        "query": "query GetFeatureGroup($getFeatureGroupInput: GetFeatureGroupInput) { getFeatureGroup (getFeatureGroupInput: $getFeatureGroupInput) }",
                        "variables": {
                            "getFeatureGroupInput": {
                                "featureGroupId": "{{ctx.featureGroupId}}",
                                "provider": "{{data.provider}}"
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{data.accsessionid}}"
            },
            "outputData": {
                "featureGroupItems": "data.data.getFeatureGroup.items"
            },
            "events": {},
            "actionMessages": {
                "failure": [
                    {
                        "message": "queryFailedMessage"
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "inputsForFeatureGroup": {
            "actionType": "JSFunction",
            "method": "getInputsForFeatureGroup",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "logSelectedObject": {
            "actionType": "JSFunctionAsync",
            "method": "logSelectedObject",
            "inputData": {
                "vmo": "{{parameters.eventData}}",
                "prop": "{{props}}"
            },
            "deps": "js/DesCatalogPartSummaryService"
        },
        "desLoadLovs": {
            "actionType": "JSFunctionAsync",
            "method": "desLoadLovs",
            "inputData": {
                "props": "{{props}}",
                "ctx": "{{ctx}}",
                "data": "{{data}}"
            },
            "outputData": {
                "featureGroupItems": "featureGroupItems"
            },
            "events": {},
            "deps": "js/CustomLOVComponentService"
        }
    },
    "data": {
        "accsessionid": "",
        "catalogspaceId": "",
        "provider": ""
    },
    "conditions": {},
    "onEvent": [
        {
            "eventId": "featureValuesProvider.selectionChangeEvent",
            "action": "logSelectedObject",
            "cacheEventData": false,
            "inputArgs": {
                "eventData": "{{eventData.selectedObjects}}"
            }
        }
    ],
    "dataProviders": {
        "featureValuesProvider": {
            "action_old": "enableTableConfiguration",
            "action": "desLoadLovs",
            "response": "{{data.featureGroupItems}}",
            "moreValuesExist": false
        }
    },
    "lifecycleHooks": {
        "onMount": "inputsForFeatureGroup",
        "render": "render"
    },
    "props": {
        "prop": {
            "type": "field"
        }
    },
    "_viewModelId": "CustomLOVComponent",
    "_uniqueViewModelId": "CustomLOVComponent"
};

    


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, awCustomLOVComponentRenderFunction, undefined, ctxImportObj );

    export default Component;